(function () {

  angular
    .module('meanApp')
    .directive('footercusto', footercusto);

  function footercusto () {
    return {
      restrict: 'EA',
      templateUrl: '/common/directives/footer/footer.template.html',
      replace: true
      /**,
      controller: 'navigationCtrl as navvm'**/
    };
  }

})();